"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var t,
    e = (t = require("react")) && "object" == typeof t && "default" in t ? t.default : t;

function n() {
  return (n = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  }).apply(this, arguments);
}

exports.default = function (t) {
  var r = t.text,
      u = t.thinkingDelay,
      i = void 0 === u ? 4e3 : u,
      o = t.minTypingDelay,
      a = void 0 === o ? 50 : o,
      f = t.maxTypingDelay,
      l = void 0 === f ? 100 : f,
      c = t.textClassName,
      s = t.styles,
      v = t.caretBackground,
      m = void 0 === v ? "#333" : v,
      p = t.cursorBlinkSpeed,
      h = void 0 === p ? 1e3 : p,
      d = t.notDisplayCaretAfterFinishes,
      g = e.useState([]),
      y = g[0],
      b = g[1],
      S = e.useState(0),
      T = S[0],
      x = S[1],
      E = e.useState(""),
      M = E[0],
      N = E[1],
      k = e.useState(!0),
      j = k[0],
      I = k[1],
      O = e.useState(!1),
      z = O[0],
      C = O[1],
      D = e.useState(1),
      F = D[0],
      w = D[1];
  e.useEffect(function () {
    var t = setInterval(function () {
      w(0), setTimeout(function () {
        w(1);
      }, 500);
    }, h);
    return function () {
      clearInterval(t);
    };
  }, [h]), e.useEffect(function () {
    var t = r.split(" ");
    b(t);
  }, [r]), e.useEffect(function () {
    if (T < y.length) {
      var t = y[T],
          e = t.length,
          n = Math.floor(Math.ceil(1 * Math.random()) * (l - a) + a);
      e > 15 ? n = Math.floor(3 * n) : e > 10 ? n = Math.floor(n / 2.5) : e < 8 ? n = Math.floor(n / 2) : e > 8 ? n = Math.floor(n / 1.5) : e < 5 && (n = Math.floor(n / .1)), n += .01 * i;
      var r = setTimeout(function () {
        N(function (e) {
          return e + t + " ";
        }), x(function (t) {
          return t + 1;
        }), I(!1);
      }, n);
      return function () {
        return clearTimeout(r);
      };
    }

    return function () {};
  }, [T, y, i, l, a]), e.useEffect(function () {
    return y.length === T + 1 && C(!0), function () {};
  }, [y, T]);
  var B = e.useCallback(function () {
    I(!1);
  }, []);
  e.useEffect(function () {
    if (0 === T) {
      var t = setTimeout(B, i);
      return function () {
        return clearTimeout(t);
      };
    }

    if (T < y.length) {
      var e = setTimeout(B, i);
      return function () {
        return clearTimeout(e);
      };
    }

    return function () {};
  }, [T, y, i, B]), e.useEffect(function () {
    if (j) {
      var t = setTimeout(B, i);
      return function () {
        return clearTimeout(t);
      };
    }

    return function () {};
  }, [j, i, B]);
  var P = e.useCallback(function () {
    I(!0);
  }, []);
  e.useEffect(function () {
    if (!j && T < y.length) {
      var t = setTimeout(P, i);
      return function () {
        return clearTimeout(t);
      };
    }

    return function () {};
  }, [j, i, T, y, P]);

  var _ = parseInt(String(null == s ? void 0 : s.height), 10),
      q = Number.isNaN(_) ? 3 : .11 * _;

  return e.createElement(e.Fragment, null, e.createElement("span", {
    style: n({}, s),
    className: c
  }, M), e.createElement("span", {
    style: {
      width: null != s && s.fontSize ? Number(Number(.5 * parseInt(String(null == s ? void 0 : s.fontSize), 10)).toFixed(0)) + "px" : "10px",
      height: null != s && s.fontSize ? Number(Number(.9 * parseInt(String(null == s ? void 0 : s.fontSize), 10)).toFixed(0)) + "px" : "17px",
      background: m,
      transform: "translateY(" + q + "px)",
      display: d && z ? "none" : "inline-block",
      opacity: F
    }
  }));
};